import { AppConfigModel } from "../abstract/app-config.model";

export class TaxDetail extends AppConfigModel {

    static override CLASS_NAME: string = 'TaxDetail';

    readonly description!: string;
    readonly lawArticle!: string;

    /**
     * Le motif peut-il être porté par la fiche d'un partenaire exonéré à titre
     * individuel ? — #1089.
     *
     * Rendu par le serveur, jamais déduit ici : les motifs territoriaux (exportations,
     * prestations hors territoire) décrivent l'opération et se posent tout seuls, alors
     * qu'une fiche partenaire dit un statut. Coder « sauf 21 et 22 » côté front, ce
     * serait mettre de la fiscalité calédonienne dans un dépôt qui n'a pas à en porter.
     */
    readonly partnerEligible!: boolean;
}
